module.exports = __webpack_public_path__ + "kudos_32.svg?15a7a3a48ee6bad2fe94c55976e228c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_32.svg
// module id = 131
// module chunks = 0